import Alpine from 'alpinejs'

Alpine.store("product", {
	selectedDimensions: null,
	selectedDiameter: null,
	shortDesc: null,
	showDiameter: null
})
